import styled from '@emotion/styled'
import { tokens } from '@news-mono/design-tokens'
import { breakpoint, calcRem } from '../../../__styling'
import { StyledElectionText } from '../components'

export const TheRaceBarIndicatorContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    flex: '1 0 0',
    position: 'relative',

    height: calcRem(32),
    maxHeight: calcRem(32),
    minHeight: calcRem(32),
    background: tokens.thenightly.colors.palette.neutral[10],
    width: '100%',
})

export const TheRaceBarIndicator = styled('div')<{
    widthPercent: number
    color: string
}>(({ widthPercent, color }) => ({
    display: 'flex',
    height: '100%',
    width: `${Math.min(widthPercent, 100)}%`,
    background: `${color}`,
    position: 'absolute',
}))

export const TheRacePartyRowContainer = styled('div')({
    display: 'flex',
    alignItems: 'flex-end',
    gap: calcRem(16),
    alignSelf: 'stretch',
})

export const TheRacePartyInnerRowContainer = styled('div')({
    display: 'flex',
    gap: calcRem(4),
    alignItems: 'center',
    flex: '1 0 0',

    // Mobile styling

    flexDirection: 'column',
    height: 'fit-content',
    width: '100%',

    // Bigger styling

    [breakpoint('lg')]: {
        flexDirection: 'row',
        width: 'auto',
        height: 'auto',
    },
})

export const StyledRaceElectionText = styled(StyledElectionText)({
    color: tokens.thenightly.colors.palette.neutral[100],

    // Mobile styling
    placeSelf: 'start',
    width: '100%',
    maxWidth: '100%',

    // Bigger styling
    [breakpoint('lg')]: {
        placeSelf: 'center',
        width: '10%',
        maxWidth: '10%',
    },
})

export const StyledRaceAmountText = styled(StyledElectionText)<{
    barPercent: number
}>(({ barPercent }) => () => {
    const isFullBar = barPercent >= 100

    return [
        {
            color: tokens.thenightly.colors.palette.neutral[100],
            fontWeight: 600,

            position: 'absolute',
        },
        isFullBar
            ? // Apply padding to make sure the number is at the end of the bar
              {
                  right: 0,
                  paddingRight: calcRem(8),
              }
            : // Else apply it after the bar
              {
                  left: `${barPercent}%`,
                  paddingLeft: calcRem(8),
              },
    ]
})
